module.exports = __webpack_public_path__ + "img/house-2@3x.1f235271.jpg";